<template>
  <button v-if="buttonType === 'button'" :class="'download__link ' + className" @click="download">
    <FontAwesomeIcon :icon="'fa-light fa-' + icon" />
    <span class="ms-2">
      <span class="download__title">{{ title }}</span>
    </span>
  </button>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "ButtonDownloadFileComponent",
  components: { FontAwesomeIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: "circle-arrow-down",
    },
    className: {
      type: String,
      required: false,
      default: "primary",
    },
    buttonType: {
      type: String,
      required: true,
    },
  },
  methods: {
    download() {
      this.$emit("download");
    },
  },
};
</script>

<style lang="scss" scoped>
.download {
  &__link {
    display: flex;
    border: 1px solid;
    padding: 20px;
    border-radius: 6px;

    svg {
      margin-top: 5px;
    }
  }

  &__title {
    color: #000;
    display: block;
    @include dark-theme {
      color: $white;
    }
  }

  &__baseline {
    display: block;
    text-align: left;
    text-decoration: underline;
  }
}
</style>
